<span
  dojoImagePreview
  [src]="dataUrl()"
  class="text-neutral-0 flex h-full w-full rounded-[0.75rem] bg-neutral-400 bg-cover bg-center dark:bg-gray-700"
  [style]="{
    'background-image': 'url(' + dataUrl() + ')',
    'background-size': 'cover',
    'background-position': '50%'
  }"
>
</span>

@if (editable()) {
  <dojo-icon-button
    (click)="removeImage.emit()"
    [iconSize]="12"
    [icon]="'close'"
    class="chat-images-remove-button absolute right-1 top-1"
    [matTooltip]="'practice.delete_image' | transloco"
  ></dojo-icon-button>
}
